import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";

const MedicalHistory = (props) => {
    logUI("MBHWeb.UI.MedicalHistory.ComponentDidMount", new Date(), Tools.getURLPath());
    const serverData = props.serverData;

    return <MyChartContainer mode="histories" title="Medical History" serverData={serverData} />;
};

export default MedicalHistory;